import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { toRef } from 'vue'
import { useFormSelect } from '@/composables'
import { SelectBase } from '@component/Miscellaneous'
import type { FormSelectOption, FormSelectValue } from '@/interfaces'


export default /*@__PURE__*/_defineComponent({
  __name: 'FormSelect',
  props: /*@__PURE__*/_mergeModels({
    placeholder: {},
    isLoading: { type: Boolean },
    isDisabled: { type: Boolean },
    isMultiple: { type: Boolean },
    isSearchable: { type: Boolean },
    options: {}
  }, {
    "searchQuery": {
  default: ""
},
    "searchQueryModifiers": {},
    "modelValue": {
  required: true
},
    "modelModifiers": {},
  }),
  emits: ["update:searchQuery", "update:modelValue"],
  setup(__props: any) {

const modelSearch = _useModel<string>(__props, "searchQuery");

const modelValue = _useModel<FormSelectValue>(__props, "modelValue");



const { selected, available, values } = useFormSelect(modelValue, toRef(() => __props.options), modelSearch, __props.isMultiple);

function onDeselect(id: string|number|null): void {
  if (!__props.isMultiple) return;

  modelValue.value = values.value.filter(value => value !== id);
}

function onSelect(id: string|number|null): void {
  modelValue.value = __props.isMultiple ? [...values.value, id] : id;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(SelectBase), {
    searchQuery: modelSearch.value,
    "onUpdate:searchQuery": _cache[0] || (_cache[0] = ($event: any) => ((modelSearch).value = $event)),
    "is-loading": _ctx.isLoading,
    "is-disabled": _ctx.isDisabled,
    "is-multiple": _ctx.isMultiple,
    "is-searchable": _ctx.isSearchable,
    options: _unref(available),
    placeholder: _ctx.placeholder,
    selected: _unref(selected),
    onDeselect: onDeselect,
    onSelect: onSelect
  }, null, 8, ["searchQuery", "is-loading", "is-disabled", "is-multiple", "is-searchable", "options", "placeholder", "selected"]))
}
}

})